import { useSoftDeployAccess } from 'App/components/hooks';
import useTaskListAllowed from 'App/pages/TaskList/allowed';

export default function useTaskMapAllowed() {
	const hasTaskList = useTaskListAllowed();
	const hasVisits = useSoftDeployAccess('CUSTOMER_VISITS');
	return hasTaskList && hasVisits;
}
